import { render } from "./calcolatoreFumo.vue?vue&type=template&id=97cd67e2&ts=true"
import script from "./calcolatoreFumo.vue?vue&type=script&lang=ts"
export * from "./calcolatoreFumo.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__